<template>
  <div class="header">
    <div class="head-top">
      <div class="logo">
        <div class="logoImg">
          <img style="height: 40px" :src="homeLogo">
        </div>
        <a-button class="login" v-if="!userInfo.id" @click="handleLogin">登录</a-button>
        <div class="isLogin" v-if="userInfo.id">
          <user-menu></user-menu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserMenu from '@/views/serviceHall/components/UserMenu'
import { mapGetters } from 'vuex'
import {getSsoAuthUrl} from "@/api/sso";
import {listPlatformConfig} from '@/api/serviceHall/serviceHall'
import storage from "store";
import {ACCESS_TOKEN} from "@/store/mutation-types";

export default {
  name: 'HallHead',
  data() {
    return {
      homeLogo: undefined
    }
  },
  components: {
    UserMenu
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    const token = storage.get(ACCESS_TOKEN)
    if (token) {
      this.listPlatformConfig()
    }
  },
  methods: {
    handleLogin() {
      const param = {
        redirectUrl: location.href,
      }
      getSsoAuthUrl(param).then((res) => {
        if (res.success) {
          location.href = res.data;
        }
      })
    },
    listPlatformConfig() {
      listPlatformConfig().then(res => {
        if (res.success) {
          const platform = res.data.filter(item => item.code === 'HOME_LOGO_ICON')
          this.homeLogo = JSON.parse(platform[0].value)[0]
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.header {
  position: relative;
  .head-top {
    width: 100%;
    height: 60px;
    border-bottom: 1px solid rgba(255,255,255,0.2);
    position: relative;
    z-index: 1;
    .logo {
      width: 1200px;
      height: 60px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;

      /deep/ .content-box {
        span {
          color: #ffffff;
        }
      }

      .navBar {
        flex: 1;
        display: flex;
        margin: 0 40px;

        .navBar-li {
          color: #A8C2E7;
          margin-top: 6px;
          margin-right: 40px;
          padding-bottom: 5px;
          font-weight: bold;
          cursor: pointer;
        }
      }

      .navBar-li.router-link-active {
        color: #FFF;
        border-bottom: 2px solid #fff;
      }

      .login {
        color: #00A4F2;
        width: 120px;
        height: 30px;
        background-color: #ffffff;
        text-align: center;
        line-height: 30px;
        font-size: 16px;
        letter-spacing: 5px;
        border-radius: 4px;
      }
    }
  }
}
</style>
